export default __webpack_public_path__ + "static/media/Rosy Walker.eb478597.png";